import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    this.render()
  }

  disconnect() {
    this.chart?.destroy()
  }

  render() {
    if (!this.hasCanvasTarget) return

    const styles = getComputedStyle(document.documentElement)
    const accent = styles.getPropertyValue("--accent").trim() || "#7C5CFC"
    const muted = styles.getPropertyValue("--muted").trim() || "#667085"
    const border = styles.getPropertyValue("--border").trim() || "#EAECF0"

    const labels = this.dataValue?.labels || []
    const values = this.dataValue?.values || []

    this.chart?.destroy()
    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels,
        datasets: [{
          data: values,
          borderColor: accent,
          backgroundColor: "transparent",
          pointBackgroundColor: accent,
          pointRadius: 3,
          pointHoverRadius: 5,
          tension: 0.3,
          borderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => this.formatBRL(ctx.parsed.y)
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: "R$", color: muted },
            ticks: {
              color: muted,
              callback: (value) => this.formatBRL(value)
            },
            grid: { color: border }
          },
          x: {
            ticks: { color: muted, maxRotation: 0, autoSkip: true, maxTicksLimit: 8 },
            grid: { display: false }
          }
        }
      }
    })
  }

  formatBRL(value) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value)
  }
}
